import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogContent, Grid, Icon } from '@mui/material'
import { isNil } from 'lodash'
import moment from 'moment'
import { toast } from 'react-toastify'
import { aquaFetch } from 'common/utils/ActionUtils'
import ApplicationConf from 'conf/ApplicationConf'
import Input from 'common/components/form/Input'
import Select from 'common/components/form/Select'
import DateTimePicker from 'common/components/form/DateTimePicker'
import { BasicDialogAction, BasicDialogTitle } from 'common/components/modal/DialogComponents'
import { LOT_STATUS_ITEMS } from './LotsUtils'

// Dialog note d'avancement : création, modification et suppression (enregistrement immédiat).
const NoteDialog = ({ note, idLot, defaults, onClose, onSaved }) => {
    const [form, setForm] = useState(note ?? { idLot, statut: defaults?.statut ?? 1, avancement: defaults?.avancement, date: moment().valueOf() })
    const change = (c) => setForm(f => ({ ...f, ...c }))
    const isEdit = !isNil(form.id)

    const save = () => {
        aquaFetch(ApplicationConf.gdl.lotNote(), { method: isEdit ? 'PUT' : 'POST', body: { ...form, idLot } })
            .then(() => {
                onSaved(); onClose()
            })
            .catch(() => toast.error('Erreur lors de l\'enregistrement de la note'))
    }
    const remove = () => {
        aquaFetch(ApplicationConf.gdl.lotNoteById(form.id), { method: 'DELETE' })
            .then(() => {
                onSaved(); onClose()
            })
            .catch(() => toast.error('Erreur lors de la suppression de la note'))
    }

    return (
        <Dialog open maxWidth='sm' fullWidth>
            <BasicDialogTitle onClose={onClose}>{isEdit ? 'Modifier la note' : 'Nouvelle note d\'avancement'}</BasicDialogTitle>
            <DialogContent>
                <Grid container columnSpacing={2} rowSpacing={1} alignItems='center' sx={{ paddingTop: 1 }}>
                    <Grid size={6}>
                        <Select label='Statut' items={LOT_STATUS_ITEMS} value={form.statut} onChange={v => change({ statut: v })} sortItems={false} />
                    </Grid>
                    <Grid size={6}>
                        <DateTimePicker label='Date' value={form.date} onChange={v => change({ date: v })} />
                    </Grid>
                    <Grid size={6}>
                        <Input label='Avancement (%)' type='number' value={form.avancement} onChange={v => change({ avancement: isNil(v) || v === '' ? undefined : Number(v) })} required />
                    </Grid>
                    <Grid size={12}>
                        <Input label='Commentaire' value={form.commentaire} onChange={v => change({ commentaire: v })} multiline />
                    </Grid>
                </Grid>
            </DialogContent>
            <BasicDialogAction
                buttonLabel={isEdit ? 'Modifier' : 'Créer'}
                onValidate={save}
                isDisabled={isNil(form.avancement) || isNil(form.date)}
            >
                {isEdit && (
                    <Button onClick={remove} variant='contained' color='error' startIcon={<Icon>delete</Icon>}>Supprimer</Button>
                )}
            </BasicDialogAction>
        </Dialog>
    )
}
NoteDialog.propTypes = { note: PropTypes.shape({}), idLot: PropTypes.number, defaults: PropTypes.shape({ statut: PropTypes.number, avancement: PropTypes.number }), onClose: PropTypes.func, onSaved: PropTypes.func }

export default NoteDialog
